// Updated MemoModalProvider.jsx
import React, { createContext, useState, useContext } from 'react';
import DeleteMemoModal from 'memos/DeleteMemoModal';
import { useDeleteMemo } from 'hooks/memos/mutations';
import { withToastManager } from 'ui/toast';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const MemoModalProvider = withToastManager((props) => {
  const { children } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  
  const deleteMemo = useDeleteMemo();

  // Updated to accept both memoId and excerptId
  const openModal = (memoId, excerptId) => {
    setIsModalOpen(true);
    setModalData({ memoId, excerptId });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const onDelete = () => {
    if (!modalData?.memoId || !modalData?.excerptId) return;
    
    const { memoId, excerptId } = modalData;
    
    // This will trigger optimistic deletion
    deleteMemo.mutate(
      { memoId, excerptId },
      {
        onError: (error) => {
          props.toastManager.add(
            'Error deleting memo. Refresh and try again.',
            {
              appearance: 'error',
              autoDismiss: true,
              autoDismissTimeout: 7000
            }
          );
        }
      }
    );
    
    closeModal();
  };

  return (
    <ModalContext.Provider value={{ openModal, isModalOpen }}>
      {children}
      <DeleteMemoModal
        show={isModalOpen}
        onCancel={closeModal}
        onDelete={onDelete}
      />
    </ModalContext.Provider>
  );
});